require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/entries.js
 ** module id = 213
 ** module chunks = 0
 **/